export default function currentDate() {
  if (window.RAILS_ENV == "test" && window.CURRENT_TIME) {
    return new Date(Date.parse(window.CURRENT_TIME))
  }

  return new Date()
}
